import React from 'react';
import fetch from "cross-fetch";
import {withFormik} from 'formik';
import * as Yup from "yup";
import config from "../config";

function BusinessForgotPasswordForm(props) {
  const {
    values,
    touched,
    errors,
    isValid,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    submitCount,
    status,
  } = props;

  if (submitCount > 0) {
    return (
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          <div>
            The password reset link has been sent to you. Please contact support if you do not receive it within 10 minutes.
          </div>
        </div>
      </div>
    );
  }


  return (
    <form onSubmit={handleSubmit}>
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          <div className={"form-group"}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.email && touched.email ? 'text-input form-control error' : 'text-input form-control'}
            />
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          <button type="submit"
                  className="btn btn-primary btn-xlg btn-block btn-pointer"
                  disabled={isSubmitting || !isValid}>
            Reset Password
          </button>
        </div>
      </div>
    </form>
  );
}


export default withFormik({
  mapPropsToValues: (props) => ({
    email: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required")
  }),
  handleSubmit: (
    values,
    {
      props,
      setSubmitting,
      setErrors,
    }) => {
    // Submit forgot password
    fetch(config.apiRoot + '/rest-auth/password/reset/', {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json'
      },
      body: JSON.stringify({
        email: values.email,
      }),
    }).then(
      response => setSubmitting(false),
      error => setSubmitting(false),
    );

  }
})(BusinessForgotPasswordForm);


// WEBPACK FOOTER //
// ./src/parts/BusinessForgotPasswordForm.js